<article class="">
    <header class="">
        <div class="">
            <ul class="list-inline d-flex justify-content-between mb-0">
                <li class="list-inline-item">
                    <h1 class="">Market Metrics</h1>
                </li>
                <li class="list-inline-item">
                    <button class="btn btn-icon btn-light-info mx-1" (click)="printPage()">
                        <i class="ti ti-printer"></i>
                    </button>
                    <button aria-label="Copy link" class="btn btn-icon btn-light-info" (click)="copyFullPageText()">
                        <i class="ti ti-copy"></i>
                    </button>
                </li>
            </ul>
        </div>
    </header>
    <div class="">
        <div class="card-body p-2">
            <p class="mt-1">Market metrics are a set of tools that help you position your ocean rates against the
                market.</p>
            <p>They are global settings that apply to all displayed market data. By setting the appropriate market
                metrics, you can narrow down the scope of the ocean freight market to only those segments that are
                specific to your business.</p>
            <p>
                <img src="../../../../../assets/img/filters.png" class="fr-fic fr-dib">
            </p>
            <div class="fr-img-space-wrap">Xeneta uses the following market metrics to set a benchmark for your ocean
                rate data:</div>
            <ul>
                <li><strong>Contract Length &amp; Contracted Within</strong></li>
                <li><strong>Market Position</strong></li>
                <li><strong>Regional Aggregation</strong></li>
                <li><strong>THC Methodology</strong></li>
            </ul>
            <h2>Contract Length</h2>
            <p>The <strong>contract length</strong> metric allows you to compare your rates against rates defined by
                short-term or long-term contracts.</p>
            <blockquote class="my-4 p-3 bg-gray-200 color-block">
                <p class="m-0">Note that long-term contracts have the
                    <a>
                        <span class="text-primary cursor-pointer"
                            (click)="goToContractedWithin('Contracted Within')">contracted
                            within</span>
                    </a> option that allows you to further filter long-term market rates by the age of their associated
                    contracts.
                </p>
            </blockquote>
            <p>See our
                <a>
                    <span class="text-primary cursor-pointer" (click)="goToContractedWithin('Contract Length')">Contract
                        Length</span>
                </a>
                article to learn more about what contracts are considered short and long-term for ocean freight.
            </p>
            <h2>Market Position</h2>
            <p>The <strong>market position</strong> metric allows you to compare your rates to the average market
                rate, as well as the market low — the lowest prices being paid by other market participants — and
                the market high — the highest prices being paid by other market participants.</p>
            <p>Take a look at our
                <span class="text-primary cursor-pointer" (click)="goToContractedWithin('Market Benchmarks')">
                    Market Benchmarks
                </span>
                article for more information on how the market position is calculated.
            </p>
            <h2>Regional Aggregation</h2>
            <p>
                The <strong>regional aggregation</strong> metric allows you to set how precise you would like the
                market rates in Xeneta to be geographically.
            </p>
            <p>
                In other words, you can choose if you only want to see rates between the exact selected ports, or —
                if there are not enough rates between them — if Xeneta can include rates from nearby ports or
                regions.
            </p>
            <p>
                To learn more, see our article on the Xeneta
                <span class="text-primary cursor-pointer" (click)="goToContractedWithin('Geo-Hierarchy Methodology')">
                    Geo-Hierarchy Methodology
                </span>
                .
            </p>
            <h2>THC Methodology</h2>
            <p>Xeneta uses its own
                <span class="text-primary cursor-pointer" (click)="goToContractedWithin('Terminal Handling Charges')">THC
                    methodology</span>
                when displaying your uploaded freight rates, based on the origin and destination regions.
            </p>
            <p>
                This methodology may not always match the actual THCs associated with your rates and as a result you
                may notice that the prices within Xeneta are different from what you expect.
            </p>
            <p>
                For cases like this, Xeneta provides the <strong>THC methodology&nbsp;</strong>metric, that allows
                you to select between using our default methodology for THCs, or using the THCs that came with your
                uploaded rates.
            </p>
            <blockquote class="my-4 p-3 bg-gray-200 color-block">
                <p class="m-0">Setting the methodology to use your own THCs will update the rates shown across all pages
                    in
                    Xeneta that feature market metrics. That includes <strong>Market Overview</strong>,
                    <strong>Performance Overview</strong>, as well as <strong>Price&nbsp;</strong>and <strong>Spend
                        Benchmarks</strong>. Exported reports will also take the selected options into account.
                </p>
            </blockquote>
        </div>
    </div>
</article>